
/* eslint-disable class-methods-use-this */
import Component from 'vue-class-component';
import Vue from 'vue';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { ModalState } from '@/core/types/modal-state';
import { ProfileAPIService } from '@/profile/services/api';
import { PinValidation, emailValidation } from '@kasasa/kloans-common-ui/dist/validations';
import { Alert } from '@/core/types/alert';
import { AlertTypeEnum } from '@/core/types/alert-type-enum';
import { CoreHelper } from '@/core/helper';
import { namespace } from 'vuex-class';

const coreNamespace = namespace('core');

@Component({
	validations: {
		pin: PinValidation.validations(),
		email: emailValidation.validations,
	},
})
export default class ProfileAcceptDwollaTermsModal extends Vue {
	public alert: Alert | null = null;

	@coreNamespace.Action('getAndSetSession')
	public getAndSetSession!: () => Promise<void>;

	public isAcceptLoading = false;

	public isShown = false;

	@Prop({ default: { isShown: false } })
	public state!: ModalState;

	@Watch('state')
	public watchState(state: { isShown: boolean }): void {
		this.isShown = state.isShown;
	}

	@Emit('accept')
	public emitAccept(): boolean {
		return true;
	}

	public termsAccepted = false;

	public wasAcceptSuccessful = false;

	public close(): void {
		this.isShown = false;
		this.reset();
	}

	public async acceptTerms(): Promise<void> {
		if (!this.termsAccepted) {
			return;
		}

		this.isAcceptLoading = true;
		this.alert = null;
		this.wasAcceptSuccessful = false;

		try {
			await ProfileAPIService.acceptDwollaTerms();
			await this.getAndSetSession();

			this.wasAcceptSuccessful = true;

			this.emitAccept();
			this.close();
		} catch (error) {
			console.error(error);

			this.alert = {
				type: AlertTypeEnum.ERROR,
				message: CoreHelper.getHttpErrorMessage(error),
			};
		}

		this.isAcceptLoading = false;
	}

	private reset(): void {
		this.alert = null;
		this.isAcceptLoading = false;
		this.wasAcceptSuccessful = false;
		this.termsAccepted = false;
	}
}
